import { Component, OnInit, Output, EventEmitter, Input, ChangeDetectionStrategy } from '@angular/core';
import { Global } from "../classes/Global";
import { BaseComponent } from "../classes/BaseComponent";
import { MediaIconHelper } from '../helpers/MediaIconHelper';

@Component({
  selector: 'app-media-selector',
  templateUrl: './media-selector.component.html',
  styleUrls: ['./media-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MediaSelectorComponent extends BaseComponent implements OnInit {

  @Input() selectedMediaType:string;
  @Input() mediaTypes: Array<any>;
  @Input() availableMediaTypes: Array<any>;
  @Input() nolinks: boolean = false; //if the media buttons are <a> tags or not
  @Output() onMediaChanged = new EventEmitter();

  constructor() {
    super();
  }

  ngOnInit() {

  }

  isActive(mediaType: string): boolean {
    return mediaType == this.selectedMediaType;
  }

  select(mediaType: string) {

    //Check if the media should be available
    if (this.availableMediaTypes == null ||
      (this.availableMediaTypes != null && this.availableMediaTypes.indexOf(mediaType) > -1)) {
      //Check if the media is different than the one currently selected
      if(mediaType != this.selectedMediaType){
        this.onMediaChanged.emit(mediaType);
      }
    }

  }

  getMaterialIcon(mediaType: string): string {
    return MediaIconHelper.getMaterialIcon(mediaType);
  }

  getMediaTypeString(mediaType): string {

    if(mediaType == "audiobooks") {
      return this.getString("audiobooks_break"); //Because it is too log, this is a version with a break in it
    }

    return this.getString(mediaType);

  }

  mediaIsAvailable(mediaType) {

    if(this.availableMediaTypes == null) {
      return true;
    }
    else {
      return this.availableMediaTypes.indexOf(mediaType) > -1;
    }
  }

  getLink(mediaType: string): string {
    return '/' + this.getCountry() + '/' + Global.getStoreUrl() + '/' + Global.getMediaTypeForUrl(mediaType) + '/' + this.getString('onSaleUrl');
  }

  getStore(): string {
    return Global.getStore();
  }

}
